import React, { ChangeEvent } from 'react';

export enum labelPositionsArray {
  top = 'inset-x-0 top-0 mt-0',
  bottom = 'inset-x-0 bottom-0',
  left = 'inset-y-0 left-0',
  right = 'inset-y-0 right-0 align-bottom',
};

export enum inputClassesArray {
  top = 'left-0 mt-7',
  bottom = 'left-0 mb-2 mt-0',
  left = 'absolute right-0 align-middle mt-0',
  right = 'left-0 absolute align-top mt-0',
};

export interface Props {
  disabled?: boolean;
  labelPosition?: keyof typeof labelPositionsArray;
  name?: string;
  selected: boolean;
  text: string;
  toggle(e: ChangeEvent<HTMLInputElement>): void;
  widthClass?: string;
  labelClass?: string;
}

export const CustomCheckbox = ({
  disabled = false,
  labelPosition = 'right',
  name,
  selected,
  text,
  toggle,
  widthClass = 'w-20',
  labelClass = 'ml-3',
}: Props): JSX.Element => {

  const inputClasses = inputClassesArray[labelPosition];
  const labelPositions = labelPositionsArray[labelPosition];

  return (
    <label
      className={`${widthClass} relative block rounded-full px-3 se:px-4 py-2 h-16 mb-3 select-none transition-all${!disabled ? ' cursor-pointer' : ''}`}
    >
      <input
        checked={selected}
        className={`peer ${inputClasses} w-6 h-6 rounded-sm inline-block bg-white checked:text-sapphire checked:border-sapphire focus:ring-0 focus:ring-offset-0 focus:outline-none`}
        disabled={disabled}
        name={name}
        onChange={toggle}
        id='checkbox'
        type='checkbox'
      />
      <span className={`${labelPositions} ${labelClass} absolute mt-2 h-8 inline-block font-semibold lg:text-sm ${disabled ? 'text-gray-400' : 'text-almostBlack'}`}>
        {text}
      </span>
    </label>
  );
}
